import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhyUsHero from './components/WhyUsHero';
import ThreeThingsSection from './components/ThreeThingsSection';
import InboundSection from './components/InboundSection';
import SixCommitments from './components/SixCommitments';
import CommitmentChat from './components/CommitmentChat';
import WrittenCommitments from './components/WrittenCommitments';
import StandardsPolicies from './components/StandardsPolicies';
import TripAdvisorWhy from './components/TripAdvisorWhy';
import VideoTestimonials from './components/VideoTestimonials';
import GreatPeople from './components/GreatPeople';
import CompanyInfo from './components/CompanyInfo';
import FinalCTA from './components/FinalCTA';

export default function WhyUsPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar dark />
      <main>
        <WhyUsHero />
        <ThreeThingsSection />
        <InboundSection />
        <SixCommitments />
        <CommitmentChat />
        <WrittenCommitments />
        <StandardsPolicies />
        <TripAdvisorWhy />
        <VideoTestimonials />
        <GreatPeople />
        <CompanyInfo />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}